import React, { useState, useEffect } from "react";
import { ProjectsGrid } from "./projects-grid";
import cn from "classnames";
import { m } from "framer-motion";
import { useRouter } from "next/router";
export default function Listing({ projectTags }) {
  const router = useRouter();
  const { tag } = router.query;
  const [activeTag, setActiveTag] = useState("All Projects");
  const total = projectTags
    ?.map((tag) => tag?.projects?.data?.length)
    .reduce((acc, current) => acc + current, 0);

  useEffect(() => {
    if (tag) {
      setActiveTag(tag);
      console.log("Active tag present in query:", tag);
    }
  }, [tag]);

  return (
    <>
      <div className="w-full lg:py-[87px] py-16 md:px-8 px-4">
        <h1 className="font-light text-darkGrey font-havletica text-center">
        Browse Our Curated Portfolio of Residential, Commercial, and Hospitality Interiors - A One-Stop Destination Redefining Luxury.
        </h1>
        {/* <p className="font-light text-center">Browse Our Curated Portfolio of Residential, Commercial, and Hospitality Interiors - A One-Stop Destination Redefining Luxury.</p> */}
      </div>
      <div className="bg-[#E9E7DE] md:px-8 px-4 flex flex-row overflow-x-auto gap-8 w-full no-scrollbar py-6 border-b-[0.5px] border-[#121111]">
        <Tab
          title={"All Projects"}
          total={total}
          onClick={() => setActiveTag("All Projects")}
          activeTag={activeTag}
        />
        {projectTags?.map((tag, key) => (
          <Tab
            title={tag?.name}
            total={tag?.projects?.data?.length}
            key={"tag" + key}
            activeTag={activeTag}
            setActiveTag={setActiveTag}
            onClick={() => setActiveTag(tag?.name)}
          />
        ))}
      </div>
      <div className="bg-[#E9E7DE] w-full md:px-8 px-4 pt-8 lg:pb-20 pb-12">
        <ProjectsGrid activeTag={activeTag} />
      </div>
    </>
  );
}
export const Tab = ({ title, activeTag, onClick, total }) => {
  return (
    <div
      className="flex flex-col items-center justify-center w-fit cursor-pointer relative pt-4 shrink-0"
      onClick={onClick}
    >
      {/* {activeTag == title && ( */}
      <m.div
        initial={{ y: 20, opacity: 0 }}
        animate={{
          y: activeTag == title ? 0 : 20,
          opacity: activeTag == title ? 100 : 0,
        }}
        transition={{ duration: 0.3 }}
        className="absolute -top-0 left-0 text-darkGrey text-sm"
      >
        ({total})
      </m.div>
      {/* )} */}

      <p
        className={cn(
          "font-havletica lg:text-lg md:text-base text-sm transition-all duration-300 ease hover:text-darkGrey",
          {
            "text-darkGrey": activeTag == title,
            "text-[#292929]/70": activeTag != title,
          }
        )}
      >
        {title}
      </p>

      <m.div
        initial={{ width: 0 }}
        animate={{ width: activeTag == title ? "100%" : 0 }}
        transition={{ duration: 0.3 }}
        className="bg-darkGrey h-[1px] mt-1 w-0 bottom-0"
      />
    </div>
  );
};
